import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { timelineSelectors } from '@store/ducks';

const BankComment = ({
  timelineStatuses,
}) => {
  const [latestSfComment, setLatestSfComment] = useState(false);
  useEffect(() => {
    const remark = timelineStatuses?.bank_status?.error;
    setLatestSfComment(remark ? remark : false);
  }, [timelineStatuses]);

  return (
    <>
    {
      latestSfComment ? (
        <div className='step-comment-container mb-3 p-2'>
          {latestSfComment}
        </div>
      ) : <></>
    }
    </>
  )
};

const mapStateToProps = (state) => ({
  timelineStatuses: timelineSelectors.getTimelineStatus(state),
});

export default connect(mapStateToProps)(BankComment);
